import { FormGroup, FormControlLabel, Checkbox } from "@material-ui/core";

import { useRef } from "react";
import { CaptureSignature } from "../../atoms"

const AddSignatureBlock = ({ signature, enable, onClick, onEnd }: any) => {
    const signRef = useRef<SignaturePad>(null);

    const handleClick = (e: any) => {
        if (e.target) {
            onClick(e.target.value)
        }
    }

    return (
        <div>
            <div>
                <FormGroup row>
                    <FormControlLabel
                        control={
                            <Checkbox
                                id="agreeSignature"
                                value="agreed"
                                checked={enable}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleClick(e)}
                            />
                        }
                        label="Agree and add signature"
                    />
                </FormGroup>
            </div>
            {enable && <div>
                <CaptureSignature signCanvasRef={signRef} imageData={signature} onEnd={onEnd} populate={true} />
            </div>}
        </div>
    )
}

export default AddSignatureBlock